import { GroupsIcon } from "icons";
import { colors } from "theme/palette";

import Box from "components/Box";
import Stack from "components/Stack";
import Text from "components/Text";

const DealTeamExplanatoryBox = () => (
  <Box
    sx={{
      marginBottom: 4,
      paddingLeft: 2,
      paddingRight: 5,
      paddingY: 3,
      borderRadius: "4px",
      maxWidth: "950px;",
      backgroundColor: colors.blue10,
    }}
  >
    <Stack spacing={2} direction="row" alignItems="center">
      <GroupsIcon sx={{ width: "60px", height: "60px" }} />

      <Stack>
        <Text variant="text2" fontWeight={700}>
          User access to checklists
        </Text>

        <Text variant="text4" marginTop={0.5} sx={{ ul: { margin: 0 } }}>
          Below is a list of all individuals that have full access to the deal.
          If you want them to access specific checklists you can either:
          <ul>
            <li>
              Share an entire checklist with everyone in a given company by
              updating the company access on the Share setting tab of the
              Checklist page; or
            </li>
            <li>
              Use the Actions button on the Checklist page to share specific
              parts of a checklist with a certain user.
            </li>
          </ul>
          The Share settings tab on the Checklist page is where you can also
          review a list of partial access users for that checklist.
        </Text>
      </Stack>
    </Stack>
  </Box>
);

export default DealTeamExplanatoryBox;
